import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import Row from "./Row";
import NoData from "./NoData";

/**
 * @name Data
 * @function
 * @description Displays Data for Each Row
 * @returns {JSX}
 * @param {*} props
 */
const Data = (props) => {
  const { parts } = useSelector((state) => ({
    parts: state.parts.data,
  }));

  return parts.length > 0
    ? parts.map((part, index) => (
        <Row
          {...part}
          key={`part-${index}`}
          selectAll={props.selectAll}
          setSelectAll={props.setSelectAll}
          className={props.className}
        />
      ))
    : null;
};

Data.propTypes = {
  data: PropTypes.array,
  excludeParameters: PropTypes.bool,
  selectAll: PropTypes.bool,
  setSelectAll: PropTypes.func,
};

export default Data;
